
const DownArrowIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none">
            <path d="M3.5 5.75L7 9.25L10.5 5.75" stroke="white" strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}

export default DownArrowIcon